<script setup>
const { productSlug, quantityLimit, addType, partnerId, isFutures } =
  defineProps({
    productSlug: {
      type: String,
      required: true,
    },
    quantityLimit: {
      type: Number,
      default: null,
    },
    addType: {
      type: String,
      default: 'addToCart',
    },
    partnerId: {
      type: Number,
      default: null,
    },
    isFutures: {
      type: Boolean,
      default: false,
    },
  })

const quantity = ref(1)
const { data: productObject } = await useFetch(`/api/product/${productSlug}/`)
const emit = defineEmits(['hide-product-details-modal'])

const showHeartIcon = ref(!isFutures)

function setQuantity(amount) {
  quantity.value = amount
}

watch(
  () => productSlug,
  () => {
    quantity.value = 1
  },
)
</script>

<template>
  <transition name="modal">
    <div
      v-if="productObject"
      class="modal-mask"
      @click="emit('hide-product-details-modal')"
    >
      <div class="modal-wrapper">
        <div
          class="modal-container ppto-pdp"
          @keyup.esc="emit('hide-product-details-modal')"
          @click.stop
        >
          <button
            class="modal-close"
            @click="emit('hide-product-details-modal')"
          >
            Close
          </button>
          <div class="wa-pdp">
            <div id="modal-upper-content" class="wa-pdp-upper">
              <ProductDetails
                :product="productObject"
                :simple="true"
                :is-futures="isFutures"
                :show-heart-icon="showHeartIcon"
                scroll-id="modal-upper-content"
              >
                <template #subheader>
                  <slot name="subheader"></slot>
                </template>
              </ProductDetails>
              <ProductStory :product="productObject" />
            </div>
            <ProductAddToCart
              v-if="quantityLimit === null || quantityLimit > 0"
              :product="productObject"
              :quantity="quantity"
              :quantity-limit="quantityLimit"
              :add-type="addType"
              :partner-id="partnerId"
              add-text="Add"
              v-bind="$attrs"
              @set-quantity="setQuantity"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
